import { getApiHostUrl } from "@/helpers/apiHelpers";
import { Tab } from "./types";

export const getNavigation = (roles: string[], userId: string, operatorId: string) => {
  const apiHostUrl = getApiHostUrl();
  const isUATorStaging = apiHostUrl.includes("uat") || apiHostUrl.includes("staging");
  const navigation: Tab[] = [
    {
      name: "Bookings",
      to: isUATorStaging ? "/bookings" : `/o/${operatorId}/booking-admin`,
      icon: "ArchiveBook",
      badge: "16",
      permission: ["manage", "providerClient"],
      isDashboard: isUATorStaging,
    },
    {
      name: "Vehicles",
      to: isUATorStaging ? "/vehicles" : `/o/${operatorId}/config/vehicle-manager`,
      icon: "Car",
      badge: "4",
      permission: ["manage", "providerConfigVehicle"],
      isDashboard: isUATorStaging,
    },
    {
      name: "Drivers",
      to: "/drivers",
      icon: "UserSquare",
      badge: "12",
      permission: ["manage", "providerDriver"],
      isDashboard: true,
    },
    {
      name: "Private Network",
      to: "/private-network",
      icon: "Global",
      permission: ["manage", "providerPrivateNetwork"],
      isDashboard: true,
    },
    {
      name: "External Suppliers",
      to: "/external-suppliers",
      icon: "People",
      badge: "5",
      permission: ["manage", "providerExternalSupplier"],
      isDashboard: true,
    },
    {
      name: "Clients",
      to: "/clients",
      icon: "Profile2User",
      badge: "5",
      permission: ["manage", "providerClient"],
      isDashboard: true,
    },
    {
      name: "Companies",
      to: "/companies",
      icon: "Buildings",
      permission: ["view", "providerCompany"],
      isDashboard: true,
    },
    {
      name: "Payments",
      to: "/payments",
      icon: "DollarCircle",
      isDashboard: true,
      permission: ["view", "providerPayments"],
    },
    {
      name: "Accreditations",
      to: "/accreditations",
      icon: "LikeTag",
      permission: ["manage", "providerAccreditations"],
      isDashboard: true,
    },
    {
      name: "User / Accounts",
      to: "/user-accounts",
      icon: "User",
      permission: ["manage", "providerAccountDirectory"],
      isDashboard: true,
    },
    {
      name: "Rating Manager",
      to: "/rating-manager",
      icon: "Star1",
      permission: ["manage", "providerRatingDriver"],
      isDashboard: true,
    },
    {
      name: "Trip Reporting",
      to: "/trip-reporting",
      icon: "DocumentText",
      permission: ["manage", "providerReportingTrip"],
      isDashboard: true,
    },
  ];

  return navigation;
};
